/**
 * The two ways a comparison can be read: side by side, with the two versions in
 * their own columns, or stacked, with both in one column.
 */
export type FPlusDiffLayout = 'split' | 'unified'

export const fplusDiffLayouts: readonly FPlusDiffLayout[] = ['split', 'unified']

export const defaultFPlusDiffLayout: FPlusDiffLayout = 'split'
